import {
    Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/special-operation';

@Module({ namespaced: true })
export default class extends VuexModule {
    @Action
    async list(params: any) {
        return api.list(params);
    }

    @Action
    async open(params: any) {
        return api.open(params);
    }

    @Action
    async edit(params: any) {
        return api.edit(params);
    }
}
